export default __webpack_public_path__ + "static/media/m_ceoLanding04.a210dcab.png";